import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Icon from "../common/icon/icon.component.jsx";
import SideBar from '../common/layout/sidebar.component.jsx';
import MyAccountTabs from "../common/layout/tabs/myaccount.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import LoadingSpinner from '../common/spinner/loading.component.jsx';
import RoleSystemName from './systemname.component.jsx';
class RoleListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            loading: false,
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        this.refreshSearch()
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })
        AppContext.getApiClient().get('/roles').then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
            })
        })

    }

    headers() {
        return [
            <FormattedMessage
                id="listing.location.list.headers.name_label"
                defaultMessage="Name"
            />,
        ]
    }

    row(item) {     
        if (item.attributes.key === 'worker') {
            return ""
        }
        return [
            <Link to={"/roles/" + item.id + '/edit'}>
                <RoleSystemName value={item.attributes.key} />
            </Link>,
        ]
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }

        return (     
            <div>
                <MyAccountTabs/>   
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                            <div className="row mb-0 justify-content-end">
                                <div className="col-3 text-align-right ">
                                    <Link to="/roles/new" className="btn btn-primary">
                                        <Icon value={"plus-circle"} />
                                        <FormattedMessage
                                            id="customers.listing.new_role_btn"
                                            defaultMessage="Create new role"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                </div>
                {list}
            </div>
        )
    }
}

export default RoleListing


// WEBPACK FOOTER //
// ./src/role/listing.component.jsx